module.exports = __webpack_public_path__ + "img/img-24.dbc53708.webp";